import React, {useState, useEffect} from 'react'
import { Modal, Button, Tooltip, OverlayTrigger } from 'react-bootstrap';

export default ({}) => {


    return (
        <Button variant="light" className="fas fa-boxes-packing text-info p-0 mr-1" style={{ border: "transparent", backgroundColor: "transparent", boxShadow: "none", outline: "none" }}></Button>
    )
}